interface GetFastshotHeaderValuesOptions {
  headers: Headers;
}

export const getFastshotHeaderValues = (options?: GetFastshotHeaderValuesOptions) => {
  return {
    height: Number(options?.headers.get("x-height") ?? 0),
    htmlTree: options?.headers.get("x-htmltree") ?? "",
    pdf: options?.headers.get("x-pdf") === "1" || options?.headers.get("Content-Type") === "application/pdf",
    title: decodeURIComponent(options?.headers.get("x-title") ?? ""),
    width: Number(options?.headers.get("x-width") ?? 0),
  };
};
